import { kebabCase } from 'lodash';

const convertToSlug = name => kebabCase(name);

export { convertToSlug };
